export default __webpack_public_path__ + "static/media/440.33332e36.jpg";